function SentryFallback() {
    return <h1>Whoops, we didn't expect this. Try refreshing this page!</h1>
}

export default SentryFallback
